export enum ApiTabsKeys {
  METRICS = "METRICS",
  COMPANIES = "COMPANIES",
  PLUGIN_USERS = "PLUGIN_USERS",
}

export const DEFAULT_API_TAB_KEY = ApiTabsKeys.METRICS;
